import "./VehiclesActivities.scss";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";
import { useState } from "react";

import { fetchVehiclesDetails } from "../../../../../slices/vehiclesDetailsSlice";

import { Avatar } from "../../../../../common-components/Avatar/Avatar";

const VehiclesActivities = ({ id }) => {
    const activities = useSelector((state) => state.vehiclesDetails.activities);


    return (
        <div className="vehicles-activities">
            <div className="vehicles-activities_container">
                <div className="vehicles-activities_title">Действия</div>

                <div className="vehicles-activities_content">
                    {activities.map((activity, idx) => (
                        <div
                            key={`${activity.by}-${activity.when}-${idx}`}
                            className="vehicles-activities_description"
                        >
                            <div className="vehicles-activities_profile">
                                <div className="vehicles-activities_by">{activity.by}</div>
                                <div className="vehicles-activities_when">{activity.when}</div>
                            </div>

                            <div className="vehicles-activities_info">
                                <div>{activity.description}</div>

                                {Array.isArray(activity.changes) &&
                                    activity.changes.map((change, cIdx) => (
                                        <div key={`${idx}-change-${cIdx}`} className={"vehicles-activities_change"}>
                                            {change}
                                        </div>
                                    ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default VehiclesActivities;